export default "__VITE_ASSET__$U0gxyng__"